export default __webpack_public_path__ + "static/media/tfg.78ae34c8.jpg";